import ListItemRightData from './list-item-right-data';

export default ListItemRightData;
